import React, { useState } from 'react';
import { Col, Button } from 'react-bootstrap';
function ContactUs() {
  // State for expanded items in the accordion
  // Handler to toggle all items to expanded state
  // Handler to toggle all items to collapsed state
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
        </div>
        <div className="col-12">
        </div>
      </div>
    </div>
  );
}
export default ContactUs;
